<template>
  <MyOrdersCard :to="`/my-orders/subscription/${latestOrderId}`" variant="default">
    <template #header>
      <LcLotteryLogo v-bind="{ licensedTerritory, lotteryId }" />
    </template>

    <template #header-end>
      <slot name="header" />
    </template>

    <template #list>
      <IconListItemId :id="code" :label="$t('common.words.subscriptionid')" />

      <MyOrdersListItemPlay
        v-bind="{ lotteryId, numberOfExtraHitPlays, numberOfPlays }"
        :add-ons="selectedAddOns"
      />

      <MyOrdersListItemParticipating v-if="prepaidOptions" v-bind="{ prepaidOptions }" />

      <IconListItemDate v-bind="{ date }" :label="dateLabel" />
    </template>

    <template #replay-button>
      <MyOrdersReplayButton
        v-if="showReplayButton"
        v-bind="{ lotteryId, playSlipOrderId: latestPlaySlipOrderId }"
        class="py-none px-400"
        size="small"
        @click.stop.prevent
      />
    </template>

    <template #cta>
      {{ $t('myorders.card.subscription.cta') }}
    </template>
  </MyOrdersCard>
</template>

<script lang="ts" setup>
import {
  type SubscriptionMultipleLines,
  SubscriptionStatus,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

import MyOrdersListItemParticipating from './MyOrdersListItemParticipating.vue'

type MyOrdersSubscriptionCardProps = {
  code: SubscriptionMultipleLines['code']
  date?: Date | string
  latestOrderId: SubscriptionMultipleLines['latestOrderId']
  latestPlaySlipOrderId?: SubscriptionMultipleLines['latestPlaySlipOrderId']
  licensedTerritory: SubscriptionMultipleLines['licensedTerritory']
  lotteryId: SubscriptionMultipleLines['lotteryId']
  nextDate?: Date | string
  numberOfExtraHitPlays: SubscriptionMultipleLines['numberOfExtraHitPlays']
  numberOfPlays: SubscriptionMultipleLines['numberOfPlays']
  prepaidOptions?: SubscriptionMultipleLines['prepaidOptions']
  replayable: SubscriptionMultipleLines['replayable']
  selectedAddOns: SubscriptionMultipleLines['selectedAddOns']
  status: SubscriptionMultipleLines['status']
}

const { t } = useI18n()

const props = defineProps<MyOrdersSubscriptionCardProps>()
const showReplayButton = computed(() => props.latestPlaySlipOrderId && canReplayLotteryOrder(props))

const dateLabel = computed(() =>
  props.status === SubscriptionStatus.Active
    ? t('myorders.detail.playslip.nextdate.label')
    : t('myorders.detail.playslip.lastdate.label'),
)
</script>
